// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/style.css
// module id = 28
// module chunks = 0